import { ReactNode } from 'react';
import { SWRConfig } from 'swr';
import { getSwrFetcher } from '../utils/get-swr-fetcher';

type AuthenticatedApiCallsProviderProps = {
  children: ReactNode;
};

export const SwrProvider = ({ children }: AuthenticatedApiCallsProviderProps) => {
  return <SWRConfig value={{ fetcher: getSwrFetcher }}>{children}</SWRConfig>;
};
